import ExternalApplicationItem from '../components/ExternalApplicationItem';
import { ExternalApplicationDetails, ExternalApplicationType } from '../types/externalApplication';

type FinthesisSpecificType = {
	organisation: string;
	project: string;
};

const Finthesis = ({ name }: ExternalApplicationType) => <ExternalApplicationItem name={name} />;

export const getDetails = ({
	name,
	specific,
}: Pick<ExternalApplicationType, 'name' | 'specific'>): ExternalApplicationDetails => {
	const jsonSpecific = specific ? (JSON.parse(specific) as FinthesisSpecificType) : undefined;
	const { organisation, project } = jsonSpecific ?? {};

	if (!organisation) {
		throw new Error('The Finthesis app organisation is missing.');
	} else if (!project) {
		throw new Error('The Finthesis app project is missing.');
	}

	return {
		name,
		url: `https://user-dashboard.io/organisations/${organisation}/projects/${project}`,
		component: <Finthesis name={name} specific={specific} />,
	};
};
